import React, {useState, useEffect} from 'react';
import t from '../../../../helpers/t';

import {contingentsActions, membershipTypeActions, userActions, useSelector} from "inbooma-api";
import { Biscuit } from "../../../../../utils";
import {$, moment} from "../../../../../../vendor";
import UserInput from '../UserInput';
import Select from "react-select";
import ComboSelect from "../../../../components/ComboSelect";


const UserGroupItemView = (props) => {
    // initialize user - set selected user or set defaults
    const [userGroup, setUserGroup] = useState(
        (props.usergroup === null) ?{
            client_id: Number(Biscuit.get('user.client_id')),
            name: null,
            domain: null,
            contingents: [],
            pricetariffs: [],
            locations: [],
            id: null,
            default_type: false
        }: props.usergroup
    );

    const [itemState, setItemState] = useState('init');                 // init, pending_tasks, pending_created, pending_modified, ready, saving

    const _userGroup = useSelector(state => state.membership_types_data.membershipType);
    const [formError,setFormError] = useState({});                      // object of error items such as 'email'
    const [initialized,setInitialized] = useState(false);
    const [selectedContingents, setSelectedContingents] = useState(typeof props.usergroup?.contingents === 'undefined'?[]: props.usergroup?.contingents);
    const [contingentsPending,setContingentsPending] = useState(false);
    const [contingents,setContingents] = useState([]);
    const _contingents = useSelector(state => state.contingents_data.contingents);
    const [amounts,setAmounts] = useState({});
    const [contingentsResults,setContingentsResults] = useState([]);
    const [contingentsResultsHidden,setContingentsResultsHidden] = useState(true);
    const [createdBy, setCreatedBy] = useState({
        id: null,
        first_name: '',
        last_name: ''
    });
    const [modifiedBy, setModifiedBy] = useState({
        id: null,
        first_name: '',
        last_name: ''
    });
    const _user = useSelector(state => state.users_data.user);
    let language = Biscuit.get('user.lang');

    useEffect(() => {
        if(_contingents.success === '' || !contingentsPending){return;}
        if(_contingents.success === true){
            setContingents(_contingents.data);
        } else {
            console.log('Fail to fetch contingents');
        }
        setContingentsPending(false);
        setInitialized(true);
    },[_contingents])

    const getUsernameById = (id) => {

        if (typeof id === 'undefined' || id === null) return t('unknown',null,'capital');

        if (createdBy.id === id) {
            if (createdBy.first_name === '' && createdBy.last_name === '') return t('unknown',null,'capital');
            if (createdBy.first_name === '') return createdBy.last_name;
            if (createdBy.last_name === '') return createdBy.first_name;
            return createdBy.first_name + ' ' + createdBy.last_name;
        }

        if (modifiedBy.id === id) {
            if (modifiedBy.first_name === '' && modifiedBy.last_name === '') return t('unknown',null,'capital');
            if (modifiedBy.first_name === '') return modifiedBy.last_name;
            if (modifiedBy.last_name === '') return modifiedBy.first_name;
            return modifiedBy.first_name + ' ' + modifiedBy.last_name;
        }
        return t('unknown',null,'capital');
    };
    const _initialize = () => {

        if(contingentsPending || initialized) return;
        // fetch created_by and modified_by
        if (itemState === 'init' && typeof userGroup.id !== 'undefined' && userGroup.id !== null) {
            if (typeof userGroup.created_by !== 'undefined' && userGroup.created_by !== null) {
                props.dispatch(userActions.getUser({
                    id: userGroup.created_by,
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setItemState('pending_created');
            }
        }
        props.dispatch(contingentsActions.getContingents(
            {
                token: Biscuit.get('token'),
                filter: {
                    'findForSelect': true,
                    'limit': 1000
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }
        ));
        setContingentsPending(true);
        if(typeof userGroup.contingents_membership_types !== 'undefined' && userGroup.contingents_membership_types.length > 0){
            let clone={};
            Object.assign(clone,amounts);
            userGroup.contingents_membership_types.map(ct =>{
                if(ct.count !== null) {
                    clone[ct.contingent_id] = ct.count;
                }
            });
            setAmounts(clone);
        }
    };
    if(!initialized){
        _initialize()
    }


    useEffect(() => {

        if (_user.success === "") return;

        if (_user.success === true && itemState === 'pending_created') {

            var name = '';
            setCreatedBy({..._user.data});
            props.dispatch(userActions.getUser({
                id: userGroup.modified_by,
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setItemState('pending_modified');
        }
        else if (_user.success === true && itemState === 'pending_modified') {
            var name = '';
            setModifiedBy({..._user.data});
            setItemState('ready_modified');
        }

        if (_user.success === false && itemState === 'pending_created') {
            props.dispatch(userActions.getUser({
                id: userGroup.modified_by,
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setItemState('pending_modified');
        }
        else if (_user.success === false && itemState === 'pending_modified') {
            setItemState('ready_modified');
        }
    },[_user]);

    _initialize();

    useEffect(() => {
        if (_userGroup.success === "") {
            return;
        }
        if (itemState !== 'saving') return;
        if (_userGroup.data.success === true) {
            props.showNotification('success', _userGroup.data.id,'','usergroup');
        }

        if (_userGroup.success === false) {
            props.showNotification('warning', 0);
        }

        //


        // close window
        abortButtonRef.current.click();
    }, [_userGroup]);

    useEffect(() => {
        let clone = {};
        Object.assign(clone,userGroup);
        clone.contingents = selectedContingents;
        setUserGroup(clone);
    }, [selectedContingents])

    // evaluate form and send user to api
    const onSubmit = () => {
        let usergroupcopy = {};
        Object.assign(usergroupcopy,userGroup);

        usergroupcopy.pricetariffs = usergroupcopy.pricetariffs.map(pricetariff => { return { id: pricetariff.id } });
        //usergroupcopy.contingents = usergroupcopy.contingents.map(contingent => { return { id: contingent.id } });
        usergroupcopy.locations = usergroupcopy.locations.map(location => { return { id: location.id } });
        if(typeof usergroupcopy.locations !== 'undefined') {
            usergroupcopy.locations = usergroupcopy.locations.map(location => {
                return {id: location.id}
            });
        }
        if(typeof usergroupcopy.contingents_membership_types !== 'undefined'){
            delete usergroupcopy.contingents_membership_types;

        }
        usergroupcopy.contingents_membership_types = usergroupcopy.contingents.map(contingent => { return { contingent_id: contingent.id, count: (typeof amounts[contingent.id] !== 'undefined' && amounts[contingent.id] !== "0" && amounts[contingent.id] !=="")?Number(amounts[contingent.id]):null } });
        delete usergroupcopy.contingents;
        if(typeof usergroupcopy.locations_membership_types !== 'undefined'){
            delete usergroupcopy.locations_membership_types;
        }
        if(typeof usergroupcopy.memberships !== 'undefined'){
            delete usergroupcopy.memberships;
        }
        let errmsg = '';

        if(errmsg !== ''){
            props.showNotification('warning', props.usergroup.id,'saving',errmsg + " " + t("are required"),'usergroup');
            return;
        }

        if (typeof userGroup.id !== 'undefined' && userGroup.id !== null) {
            props.dispatch(membershipTypeActions.editMembershipType({
                id: userGroup.id,
                data: usergroupcopy,
                token: Biscuit.get('token')
            }));
        }
        else {
            props.dispatch(membershipTypeActions.addMembershipType({
                data: usergroupcopy,
                token: Biscuit.get('token')
            }));
        }
        setItemState('saving');
    };

    const onExtraAmountChange = (e, item) => {
        let clone = {};
        Object.assign(clone, amounts);
        clone[item.id] = e.target.value;
        console.log(clone);
        setAmounts(clone);
    };


    const onContingentRemove = (e,contingent,index) => {
        let clone = [...selectedContingents];
        clone.splice(index,1);
        setSelectedContingents(clone);
    };
    const onContingentSearchClicked = (e) => {
        document.getElementsByClassName('select2-search__field2')[0].style.width = "9em";
        document.getElementsByClassName('select2-search__field2')[0].focus();
        setContingentsResults([..._contingents.data]);
        setContingentsResultsHidden(false);
    };

    const onContingentSearchChanged = (e) => {

        const value = e.target.value;
        let results = [];
        if (value.length == 0) {
            setContingentsResults([..._contingents.data]);
        } else {
            results = [];
            // search for locations with name starting with query (value)
            for (var i=0;i<_contingents.data.length;i++) {
                if (_contingents.data[i].name.toLowerCase().startsWith(value) ) results.push(_contingents.data[i]);
            }
            setContingents(results);
        }
    };
    const onContingentSearchBlur = (e) => {
        setTimeout(() => {
            setContingentsResultsHidden(true);
            document.getElementsByClassName('select2-search__field2')[0].value = "";
        },200);
    };

    const onContingentsSelectHandle = (e,contingent) => {
        // add selection to array if not already selected
        if (!e.target.parentNode.classList.contains("selected")) {
            let clone = [];
            clone = [...selectedContingents];
            clone.push({
                id: contingent.id,
                name: contingent.name
            });
            setSelectedContingents(clone);
        };
    };

    const onContingentsChangedHandler = contingents => {
        let clone = {};
        Object.assign(clone, userGroup);
        if(contingents === null){
            clone.contingents = [];
            setUserGroup(clone);
            return;
        }
        Object.assign(clone, userGroup);
        clone.contingents = contingents.map(contingent => { return { id: contingent.value, name: contingent.label } });
        setUserGroup(clone);
    }

    const onPricetariffsChangedHandler = pricetariffs => {
        let clone = {};
        Object.assign(clone, userGroup);
        if(pricetariffs === null){
            clone.pricetariffs = [];
            setUserGroup(clone);
            return;
        }
        clone.pricetariffs = pricetariffs.map(pricetariff => { return { id: pricetariff.value, name: pricetariff.label } });
        setUserGroup(clone);
    }

    const onLocationsChangedHandler = locations => {
        let clone = {};
        Object.assign(clone, userGroup);
        if(locations === null){
            clone.locations = [];
            setUserGroup(clone);
            return;
        }
        clone.locations = locations.map(location => { return { id: location.value, name: location.label } });
        setUserGroup(clone);
    }

    const onContingentsQueryHandle = (query) => {
        props.dispatch(contingentsActions.getContingents({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1,
                q: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const inputMax = (elem) => {
        console.log(elem);
        return 10;
    }

    const onChangeForm = (e) => {

        let clone = {};
        Object.assign(clone, userGroup);

        let formErrorClone = {...formError};
        $('#usergroup_item_input_'+e.target.name).css('border-color','#e3e3e3');
        switch (e.target.name) {
            case 'name':
                clone.name = e.target.value;
                if (typeof formError.name !== 'undefined') {
                    delete formErrorClone.name;
                    setFormError(formErrorClone);
                }
                break;
            case 'domain':
                clone.domain = e.target.value;
                // to-do: check e-mail format
                if (typeof formError.domain !== 'undefined') {
                    delete formErrorClone.domain;
                    setFormError(formErrorClone);
                }
                break;
            case 'default_type':
                clone.default_type = e.target.checked;
                break;

        }
        setUserGroup(clone);             // set object state
    };
    const abortButtonRef = React.createRef();
    let returnUrl = (typeof props.requestPath !== 'undefined') ? props.requestPath : '/usersExtension/userGroups';
    return (
      <>
        <div className='js-off-canvas-overlay is-overlay-fixed is-visible'></div>
        <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" data-close-on-click="false" aria-hidden="false">
            <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
                <h1 className="inb-page-title">{(userGroup.id !== null)?t('edit_${a}',{a:t('usergroup',null,'capital')}):t('add_${a}',{a:t('usergroup',null,'capital')})}</h1>
                <div className="off-canvas__actions column">
                    <button type="submit" className={"button medium beautify beautify-" + Biscuit.get('user.client_id') + " button-submit round"} title={t('save',null,'capital')} onClick={onSubmit}>
                        {itemState != 'saving' &&
                        <>
                          <i className="fi fi-check"></i>
                          <span>{t('save')}</span>
                        </>
                        }
                        {itemState === 'saving' &&
                          <span><img className="rollingLoader" src="assets/img/rolling_loader.svg" />{t('save')}</span>
                        }
                    </button>
                    <a
                        href={returnUrl}>
                        <button ref={abortButtonRef} type="button" id="inb-resourcesform-abort-button" className="button hollow secondary right button-abort round" title="Fenster schließen">
                            <i className="fi fi-x"></i>
                        </button>
                    </a>
                </div>
            </header>
            { typeof userGroup.id !== 'undefined' && userGroup.id != null &&
            <p className="off-canvas__subtitle off-canvas__header-region">
                {typeof userGroup.created !== 'undefined' &&
                t('created_at') + " " + moment(userGroup.created).format('DD.MM.YYYY HH:mm:ss') + " " +
                t('edited_by') + " " + getUsernameById(userGroup.created_by) + " | " +
                t('last_modified_at') + " " + moment(userGroup.modified).format('DD.MM.YYYY HH:mm:ss') + " " +
                t('edited_by') + " " + getUsernameById(userGroup.modified_by)
                }
            </p>
            }
            <form className="off-content row">
                <UserInput
                    value={{name: 'name', display_name: t('name'), required_be:true}}
                    val={userGroup.name}
                    name={'name'}
                    getAvailableRoles={[]}
                    onChangeForm={onChangeForm}
                    formError={formError}
                    type='extraField'
                />
                <UserInput
                    value={{name: 'domain', display_name: t('domain'), required_be:false}}
                    val={userGroup.domain}
                    name={'domain'}
                    getAvailableRoles={[]}
                    onChangeForm={onChangeForm}
                    formError={formError}
                    type='extraField'
                />
                <div className="inb-form-group column medium-3 small-3">
                    <label className="inb-form__controlLabel">{t('default',null,'capital')}</label>
                    <div className="inb-form__controllClass">
                        <input type="checkbox" onChange={onChangeForm} name="default_type" checked={userGroup.default_type}/>
                    </div>
                </div>
                <div className="inb-form-group column medium-12 small-12"><hr/></div>
                {contingents.length > 0 &&
                <>
                    <div className="inb-form-group column medium-12 small-12 lang">
                        <label className="inb-form__controlLabel">{t('contingents', null, 'capital')}</label>
                        <span className="inb-form__controlLabel size-12">{t('contingents_help', null, 'capital')}</span>
                        <div className="inb-form__controllClass">
                            {/*<Select3
                        placeholder={t('select_${a}',{a:t('contingent')})}
                        data={props.contingents}
                        nameAttribute={"name"}
                        selectHandle={onContingentsChangedHandler}
                        queryHandle={onContingentsQueryHandle}
                        zIndex={1}
                        inputMax={inputMax}
                        inputClass={"input-in-select"}
                    />*/}


                            {/*<Select
                                className="form-control"
                                name="contingents"
                                value={typeof userGroup.contingents === 'undefined' ? [] : userGroup.contingents.map(contingent => typeof contingent.id !== 'undefined' ? {
                                    value: contingent.id,
                                    label: contingent.name
                                } : [])}
                                isMulti="true"
                                onChange={onContingentsChangedHandler}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: '3px',
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#EB6A3A',
                                        primary: '#EB6A3A',
                                    },
                                })}
                                placeholder={t('select_${a}', {a: t('contingent')})}
                                options={contingents.map(contingent => {
                                    return {value: contingent.id, label: contingent.name}
                                })}
                            />
*/}
                            <ComboSelect
                                placeholder={t('select_${a}', {a: t('contingent')})}
                                onClickedHandler={onContingentSearchClicked}
                                onRemoveHandler={onContingentRemove}
                                onItemSearchChanged={onContingentSearchChanged}
                                onItemSearchBlur={onContingentSearchBlur}
                                itemResultsHidden={contingentsResultsHidden}
                                onItemsSelectHandle={onContingentsSelectHandle}
                                selectedItems={selectedContingents}
                                allItems={contingents}
                                extraAmount={false}
                                amountValue={amounts}
                                amountLabel={t('begrenzen?')}
                                onExtraAmountChange={onExtraAmountChange}
                                valkey={'id'}
                                valprop={'name'}/>
                        </div>
                    </div>
                    <div className="inb-form-group column medium-12 small-12">
                        <hr/>
                    </div>
                </>
                }
                <div className="inb-form-group column medium-12 small-12 lang">
                    <label className="inb-form__controlLabel">{t('pricetariffs',null,'capital')}</label>
                    <span className="inb-form__controlLabel size-12">{t('pricetariffs_help', null, 'capital')}</span>
                    <div className="inb-form__controllClass">
                        <Select
                            className="form-control"
                            name="pricetariffs"
                            value={typeof userGroup.pricetariffs === 'undefined' ? [] : userGroup.pricetariffs.map(pricetariff => typeof pricetariff.id !== 'undefined' ? { value: pricetariff.id, label: pricetariff.name } : [])}
                            isMulti="true"
                            onChange={onPricetariffsChangedHandler}
                            theme={theme => ({
                                ...theme,
                                borderRadius: '3px',
                                colors: {
                                    ...theme.colors,
                                    primary25: '#EB6A3A',
                                    primary: '#EB6A3A',
                                },
                            })}
                            placeholder={t('select_${a}',{a:t('pricetariff')})}
                            options={props.pricetariffs.map(pricetariff => { return { value: pricetariff.id, label: pricetariff.name }})}
                        />

                    </div>
                </div>

               <div className="inb-form-group column medium-12 small-12">
                    <hr/>
                </div>
                    <div className="inb-form-group column medium-12 small-12 lang">
                    <label className="inb-form__controlLabel">{t('locations',null,'capital')}</label>
                    <span className="inb-form__controlLabel size-12">{t('locations_help', null, 'capital')}</span>
                    <div className="inb-form__controllClass">
                    <Select
                    className="form-control"
                    name="contingents"
                    value={typeof userGroup.locations === 'undefined' ? [] : userGroup.locations.map(location => typeof location.id !== 'undefined' ? {value: location.id, label: location.name} : [])}
                    isMulti="true"
                    onChange={onLocationsChangedHandler}
                    theme={theme => ({
                    ...theme,
                    borderRadius: '3px',
                    colors: {
                    ...theme.colors,
                    primary25: '#EB6A3A',
                    primary: '#EB6A3A',
                },
                })}
                    placeholder={t('select_${a}',{a:t('location')})}
                    options={props.locations.map(location => {return {value: location.id, label: location.name}})}
                    />

                    </div>
                    </div>
            </form>

        </div>
      </>
    );
};

export default UserGroupItemView;